import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=9ed8f008&scoped=true&"
import script from "./UpdateInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&id=9ed8f008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed8f008",
  null
  
)

export default component.exports